"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Preferences;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@material-ui/core");
var _saraivaUi = require("@minha-biblioteca/saraiva-ui");
var _styles = _interopRequireDefault(require("./styles"));
var _themes = require("../../themes");
var _contexts = require("../../contexts");
var _oneColumn = _interopRequireDefault(require("../../assets/oneColumn.svg"));
var _twoColumns = _interopRequireDefault(require("../../assets/twoColumns.svg"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } /* eslint-disable react/no-array-index-key, no-use-before-define, react/jsx-no-bind */ // Styles
// Contexts
// Assets
function BackgroundColorButtons(_ref) {
  var {
    classes,
    backgroundStyle,
    handleBackgroundStyle
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.colorContainer
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    label: "Padr\xE3o",
    backgroundColor: _themes.defaultTheme.backgroundColor,
    onClick: () => handleBackgroundStyle('default'),
    selected: backgroundStyle === 'default'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spaceBetween
  }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    label: "Claro",
    backgroundColor: _themes.brighterTheme.backgroundColor,
    onClick: () => handleBackgroundStyle('brighter'),
    selected: backgroundStyle === 'brighter'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spaceBetween
  }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    label: "S\xE9pia",
    backgroundColor: _themes.sepiaTheme.backgroundColor,
    onClick: () => handleBackgroundStyle('sepia'),
    selected: backgroundStyle === 'sepia'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spaceBetween
  }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    label: "Escuro",
    backgroundColor: _themes.darkTheme.backgroundColor,
    onClick: () => handleBackgroundStyle('dark'),
    selected: backgroundStyle === 'dark',
    colorSelected: "white"
  }));
}
function ColumnButtons(_ref2) {
  var {
    classes,
    columnType,
    handleColumnType
  } = _ref2;
  var matches = (0, _core.useMediaQuery)('(min-width:769px)');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: matches ? classes.columnContainer : classes.mobile
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    label: "Uma Coluna",
    size: "large",
    onClick: () => handleColumnType('one'),
    image: _oneColumn.default,
    selected: columnType === 'one'
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spaceColumns
  }), /*#__PURE__*/_react.default.createElement(_saraivaUi.CardSelect, {
    label: "Duas Colunas",
    size: "large",
    onClick: () => handleColumnType('two'),
    image: _twoColumns.default,
    selected: columnType === 'two'
  }));
}
function Preferences() {
  var classes = (0, _styles.default)();
  var matches = (0, _core.useMediaQuery)('(min-width:769px)');
  var {
    fontButton,
    increaseFont,
    decreaseFont,
    columnType,
    handleColumnType,
    backgroundStyle,
    handleBackgroundStyle
  } = (0, _react.useContext)(_contexts.ReaderPreferencesContext);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "reader-preferences"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "textPrimary",
    className: classes.title
  }, "Tamanho do Texto:")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.buttons
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.sizeText
  }, fontButton.fontPercentageValue, "%")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.groupButtons
  }, /*#__PURE__*/_react.default.createElement(_saraivaUi.IncreaseReduceButton, {
    handleDecrease: /*#__PURE__*/_asyncToGenerator(function* () {
      return increaseFont();
    }),
    disableDecrease: fontButton.disableIncreaseButton,
    handleIncrease: () => decreaseFont(),
    disableIncrease: fontButton.disableDecreaseButton
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "textPrimary",
    className: classes.title
  }, "Cor do Fundo")), /*#__PURE__*/_react.default.createElement(BackgroundColorButtons, {
    classes: classes,
    backgroundStyle: backgroundStyle,
    handleBackgroundStyle: handleBackgroundStyle
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: matches ? classes.root : classes.mobile
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "subtitle2",
    color: "textPrimary",
    className: classes.title
  }, "Tipo de Coluna")), /*#__PURE__*/_react.default.createElement(ColumnButtons, {
    classes: classes,
    columnType: columnType,
    handleColumnType: handleColumnType
  }));
}
BackgroundColorButtons.propTypes = {
  classes: _propTypes.default.shape({
    colorContainer: _propTypes.default.string.isRequired,
    spaceBetween: _propTypes.default.string.isRequired
  }).isRequired,
  backgroundStyle: _propTypes.default.string.isRequired,
  handleBackgroundStyle: _propTypes.default.func.isRequired
};
ColumnButtons.propTypes = {
  classes: _propTypes.default.shape({
    columnContainer: _propTypes.default.string.isRequired,
    mobile: _propTypes.default.string.isRequired,
    spaceColumns: _propTypes.default.string.isRequired
  }).isRequired,
  columnType: _propTypes.default.string.isRequired,
  handleColumnType: _propTypes.default.func.isRequired
};